import React from 'react';
import styles from '../styles/CashOutModal.module.css';

interface CashOutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onJustCashOut: () => void;
  onCashOutAndPlayAgain: () => void;
  isLoading?: boolean;
}

export const CashOutModal: React.FC<CashOutModalProps> = ({
  isOpen,
  onClose,
  onJustCashOut,
  onCashOutAndPlayAgain,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.cashOutOverlay} onClick={onClose}>
      <div className={styles.cashOutModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.cashOutHeader}>
          <h2 className={styles.cashOutTitle}>💰 Cash Out</h2>
        </div>
        
        <div className={styles.cashOutContent}>
          <p className={styles.cashOutDescription}>
            Choose <strong>Cash Out & Play Again</strong> to cash out and start a new game in a single transaction, which saves your gas fee cost.
            And you will get a <strong>free DXF Mining Boost</strong> utility as rewards!
          </p>
          
          <div className={styles.cashOutButtons}>
            <button
              onClick={onJustCashOut}
              disabled={isLoading}
              className={styles.cashOutButton}
            >
              {isLoading ? 'Processing...' : 'Just Cash Out'}
            </button>
            <button
              onClick={onCashOutAndPlayAgain}
              disabled={isLoading}
              className={`${styles.cashOutButton} ${styles.primary}`}
            >
              {isLoading ? 'Processing...' : 'Cash Out & Play Again'}
            </button>
          </div>
        </div>
        
        <button
          onClick={onClose}
          disabled={isLoading}
          className={styles.cashOutClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};